import {
  Clock3Icon,
  SearchIcon,
  LayersIcon,
  FolderOpenIcon,
  UsersIcon,
  ClipboardListIcon,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export const painPoints: { icon: LucideIcon; text: string }[] = [
  { icon: Clock3Icon, text: 'You spend evenings or weekends preparing lessons.' },
  { icon: SearchIcon, text: 'You keep searching for activities that actually work.' },
  { icon: LayersIcon, text: 'You teach several grades and need different levels.' },
  { icon: FolderOpenIcon, text: 'Your resources are scattered across files and websites.' },
  { icon: UsersIcon, text: 'You want to include every student without lowering the learning goal.' },
  { icon: ClipboardListIcon, text: 'You need practical assessments without creating more paperwork.' },
]
